import { updateListMethod } from '../../utils/list';
import {
  PERIODICAL_REPORT_TOGGLE_DIALOG,
  PERIODICAL_REPORT_UPDATE_LIST,
  PERIODICAL_REPORT_UPDATE_LIST_METHOD,
  PERIODICAL_REPORT_UPDATE_FORM,
  PERIODICAL_REPORT_UPDATE_FORM_ERROR,
  PERIODICAL_REPORT_UPDATE_FORM_FIELD,
  // Periodical report current data
  PERIODICAL_REPORT_UPDATE_YEAR_LEVELS,
  PERIODICAL_REPORT_UPDATE_LEARNING_AREAS,
  PERIODICAL_REPORT_UPDATE_ASSESSMENT_AREAS,
  // Periodical report marking
  PERIODICAL_REPORT_UPDATE_STUDENTS,
  PERIODICAL_REPORT_UPDATE_STUDENT,
  PERIODICAL_REPORT_UPDATE_MODE
} from '../actions/periodical-report.actions';

const initState = {
  dialog: {
    open: false,
    type: '',
    form: {}
  },
  list: [],
  totalList: 0,
  form: {},
  formError: null,
  students: [],
  mode: {
    text: 'editing',
  },

  // Periodical report current data
  yearLevels: [],
  learningAreas: [],
  assessmentAreas: []
};

const periodicalReportReducer = (state = initState, action) => {
  const newState = { ...state };
  const { type, payload } = action;

  switch (type) {
    case PERIODICAL_REPORT_TOGGLE_DIALOG:
      if (payload.type) {
        newState.dialog.open = true;
        newState.dialog.type = payload.type;
        newState.dialog.form = payload.form;
        if (payload.type === 'create') {
          newState.dialog.form = { status: 'draft' };
        }
      } else {
        newState.dialog.open = false;
        newState.dialog.type = '';
        newState.dialog.form = {};
      }
      break;
    case PERIODICAL_REPORT_UPDATE_LIST:
      newState.list = payload.data;
      newState.totalList = payload.count;
      break;
    case PERIODICAL_REPORT_UPDATE_LIST_METHOD:
      newState.list = updateListMethod(payload.method, payload.data, newState.list);
      if (payload.method === 'DELETE') {
        newState.totalList--;
      }
      if (payload.method === 'POST') {
        newState.totalList++;
      }
      break;
    case PERIODICAL_REPORT_UPDATE_FORM:
      newState.form = { ...payload };
      newState.formError = null;
      break;
    case PERIODICAL_REPORT_UPDATE_FORM_ERROR:
      newState.formError = payload;
      break;
    case PERIODICAL_REPORT_UPDATE_FORM_FIELD:
      newState.form = { ...newState.form, [payload.field]: payload.value };
      newState.formError = { ...newState.formError, [payload.field]: null };
    break;
    case PERIODICAL_REPORT_UPDATE_STUDENTS:
      newState.students = action.payload
      if (action.payload?.length === 0) {
        newState.mode = null
      }
    break     
    case PERIODICAL_REPORT_UPDATE_STUDENT:
      let students = [...newState.students]

      if (newState.students.length === 0) {
        const t = new Date()
        t.setSeconds(t.getSeconds() + 59);
        newState.mode = {
          text: 'editing',
          endDate: t
        }
      }
      const find = students.find((item) => 
        item.studentId === action.payload.studentId &&
        item.elementId === action.payload.elementId &&
        item.assessmentAreaId === action.payload.assessmentAreaId &&
        item.subElementId === action.payload.subElementId 
      )

      if (find) {
        students = newState.students.map((item) => {
          if (
            item.studentId === action.payload.studentId &&
            item.elementId === action.payload.elementId &&
            item.assessmentAreaId === action.payload.assessmentAreaId &&
            item.subElementId === action.payload.subElementId
          ) {
            return action.payload
          } else {
            return item
          }
        })
      } else {
        students.push(action.payload)
      }
      
      newState.students = [...students]
    break;
    case PERIODICAL_REPORT_UPDATE_MODE:
      newState.mode = action.payload
    break;
    case PERIODICAL_REPORT_UPDATE_YEAR_LEVELS:
      newState.yearLevels = action.payload
    break;
    case PERIODICAL_REPORT_UPDATE_LEARNING_AREAS:
      newState.learningAreas = action.payload
    break;
    case PERIODICAL_REPORT_UPDATE_ASSESSMENT_AREAS:
      newState.assessmentAreas = action.payload
    break;
    default:
      break;
  }
  return newState;
};

export default periodicalReportReducer;
